import { render } from "./BtnChevronLeft.vue?vue&type=template&id=051bfd50"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/BtnChevronLeft.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "051bfd50"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('051bfd50', __exports__)) {
    api.reload('051bfd50', __exports__)
  }
  
  module.hot.accept("./BtnChevronLeft.vue?vue&type=template&id=051bfd50", () => {
    api.rerender('051bfd50', render)
  })

}


export default __exports__